import { TraceXInterceptor } from '@trace-x/trace-x-generator';
import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {ModelStep} from "../models/modal-step.model";
import {MultiFieldInputProperty} from "@surf/surf-multi-field-input";

@Component({
  selector: 'surf-grab-pnr-details',
  templateUrl: './grab-pnr-details.component.html'
})
export class GrabPnrDetailsComponent implements OnInit {

  MODAL_STEP = ModelStep;
  @Input() properties: MultiFieldInputProperty[] = [];
  @Input() componentValue: any = [];
  @Input() disabled: boolean ;
  @Input() defaultGDS;
  @Input() isDP : boolean = false;
  @Input() isSabre : boolean = true;
  @Input() error: string = null;
  @Input() msg: string = null;
  @Input() emitOnKeyUp: boolean ;
  @Input() wrapperView: boolean ;
  @Input() stepStatus: string = null;
  @Output() usePNRPriceRecordOut: EventEmitter<Boolean> = new EventEmitter<Boolean>();
  @Output() setValidInputOut: EventEmitter<Boolean> = new EventEmitter<Boolean>();
  @Output() onValueChangeOut: EventEmitter<any> = new EventEmitter<any>();
  @HostBinding('class') classes = 'c-add-manual-item__section';
  usePNRPriceRecord : boolean = true;
  constructor() { }

  ngOnInit() {
  TraceXInterceptor.interceptTrace('dashboard/projects/surf-grab-pnr/src/lib/grab-pnr-details/grab-pnr-details.component.ts.GrabPnrDetailsComponent.ngOnInit');
  }
  checkValue(event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-grab-pnr/src/lib/grab-pnr-details/grab-pnr-details.component.ts.GrabPnrDetailsComponent.checkValue');
    this.usePNRPriceRecordOut.emit(event);
    this.usePNRPriceRecord = event.target.checked;
  }
  setValidInput(event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-grab-pnr/src/lib/grab-pnr-details/grab-pnr-details.component.ts.GrabPnrDetailsComponent.setValidInput');
    this.setValidInputOut.emit(event);
  }
  onValueChange(event): void {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-grab-pnr/src/lib/grab-pnr-details/grab-pnr-details.component.ts.GrabPnrDetailsComponent.onValueChange');
    if (this.isDP && event && event[0]) {
      if (event[0].code === 'SAB') {
        this.usePNRPriceRecord = true;
      }
    }
    this.onValueChangeOut.emit(event);
  }


}
